/**
 * Subscription Service
 * Handles all subscription-related API calls
 */

/**
 * Fetch reference/invoice data by reference ID
 * @param {string} referenceId - The payment reference ID
 * @returns {Promise<Object>} Reference data including debtor_name, amount, processed status
 */
export function getReferenceData(referenceId) {
  return axios.get(`${API}adminCustomerPanel/getByReference?referenceID=${referenceId}`)
    .then(({ data }) => data)
}

/**
 * Mark a reference as viewed by the customer
 * @param {string} referenceId - The payment reference ID
 * @returns {Promise<void>}
 */
export function markAsViewed(referenceId) {
  return axios.get(`${API}viewed?ref=${referenceId}`)
}

export default {
  getReferenceData,
  markAsViewed
}
